import styled from 'styled-components';

export const Tag = styled.div`
  vertical-align: super;
  padding-left: 3px;
  font-size: 8pt;
  display: inline-block;
  font-weight: bold;
`;

export const BetaWord = styled.span`
  background-color: #f2f8fb;
  color: #1890ff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;
